import { render, staticRenderFns } from "./AmenitiesCards.vue?vue&type=template&id=0d65acda&scoped=true&"
import script from "./AmenitiesCards.vue?vue&type=script&lang=js&"
export * from "./AmenitiesCards.vue?vue&type=script&lang=js&"
import style0 from "./AmenitiesCards.vue?vue&type=style&index=0&id=0d65acda&lang=scss&scoped=true&"
import style1 from "./AmenitiesCards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d65acda",
  null
  
)

export default component.exports